function Currency({ amount, showFractionDigits = true }: { amount: number; showFractionDigits?: boolean }) {
  return (
    <span className="text-nowrap">
      {amount.toLocaleString('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        minimumFractionDigits: showFractionDigits ? 2 : 0,
        maximumFractionDigits: 2,
      })}
    </span>
  );
}

export default Currency;
